// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__yxOmv","article":"index_article__BhfCi","articlecontent":"index_articlecontent__Ou7u7","graph":"index_graph__CwBEY","point":"index_point__Cjeip"};